import type { AppEnv } from '@hc-frontend/core-context';
import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import { getESTDate } from '@hc-frontend/core-utils-date';
import { getOpenEnrollmentDates } from '@hc-frontend/services-cdn';

import type { GetIsOepFromStateAcronymRepository } from '../../domain';

export function getIsOepFromStateAcronymFactory({
  baseUrl,
  appEnv,
}: {
  baseUrl: string;
  appEnv: AppEnv;
}): GetIsOepFromStateAcronymRepository {
  return {
    getIsOepFromStateAcronym: async (stateAcronym) => {
      const response = await getOpenEnrollmentDates({
        endpoint: baseUrl,
        appEnv,
      });

      if (response.status !== 200 || !response.body) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToGetIsOepFromStateAcronym',
              rootCause: new Error(
                `Could not get is oep for state ${stateAcronym}`,
              ),
            },
          ],
        });
      }

      let startDate;
      let endDate;
      if (stateAcronym in response.body) {
        const dateRange = response.body[stateAcronym];
        startDate = dateRange?.Default.start_date;
        endDate = dateRange?.Default.end_date;
      } else {
        startDate = response.body.Default?.start_date;
        endDate = response.body.Default?.end_date;
      }

      if (startDate && endDate) {
        startDate = new Date(startDate);
        endDate = new Date(endDate);

        const today = getESTDate(new Date());

        return createSuccessOperationResult(
          startDate <= today && today <= endDate,
        );
      }

      return createSuccessOperationResult(false);
    },
  };
}
